import React from "react";
import { useI18n } from "../i18n";
import { useSeo } from "../hooks/useSeo";
import { pathFor } from "../config/site";
import { TIMELINE, IMAGES } from "../data/structure";
import { webpageLd, articleLd, breadcrumbLd, personLd } from "../lib/jsonld";
import PageHero from "../components/PageHero";
import { Section } from "../components/Section";
import Timeline from "../components/Timeline";
import OfficialLinks from "../components/OfficialLinks";

export default function TimelinePage({ pageKey }) {
  const { lang, d } = useI18n();
  const meta = d.meta.timeline;

  useSeo({
    pageKey,
    title: meta.title,
    description: meta.description,
    jsonLd: [
      webpageLd({ lang, pageKey, title: meta.title, description: meta.description }),
      articleLd({ lang, pageKey, headline: d.timelineSection.heading, description: meta.description }),
      personLd(),
      breadcrumbLd([
        { name: d.ui.nav.home, path: pathFor(lang, "home") },
        { name: d.ui.nav.timeline, path: pathFor(lang, "timeline") },
      ]),
    ],
  });

  return (
    <>
      <PageHero
        testid="timeline-hero"
        kicker={d.timelineSection.kicker}
        title={d.timelineSection.heading}
        intro={d.pages.timeline.intro}
        image={IMAGES.goldStreaks}
      />
      <Section>
        <Timeline items={TIMELINE} />
      </Section>
      <OfficialLinks />
    </>
  );
}
